import styled from "styled-components/macro"

export const QuestionListContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  width: 100%;
`
